import { Get, Post, Put } from "services";
import { ApiPath } from "paths";

export const searchKds = async (params) => {
  const res = await Get(`${ApiPath.KDS}`, params);
  return res;
};

export const getKds = async ({ kdsId, venueId }) => {
  const res = await Get(`${ApiPath.KDS}/${kdsId}`, { venueId });
  return res;
};

export const createKds = async (body) => {
  const res = await Post(`${ApiPath.KDS}`, body);
  return res;
};

export const updateKds = async ({ kdsId, ...body }) => {
  const res = await Put(`${ApiPath.KDS_ID(kdsId)}`, body);
  return res;
};

export const updateKdsMappings = async ({ kdsId, ...body }) => {
  const res = await Put(`${ApiPath.KDS_MAPPINGS(kdsId)}`, body);
  return res;
};

